import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "../auth.service";
import { DataServiceService } from "../data-service.service";
import { DateHelperServiceService } from "../helpers/date-helper-service.service";
import { CreditHistory, User } from "../model/login";

@Component({
  selector: "app-credit-history",
  templateUrl: "./credit-history.component.html",
  styleUrls: ["./credit-history.component.scss"],
})
export class CreditHistoryComponent implements OnInit {
  newCredits = 0;
  note = "";
  userId: string = "";
  isLoading: boolean = true;
  userData: User = {
    userId: "",
    companyId: "",
    user: "",
    userName: "",
    email: "",
    password: "",
    totalCreditsEntitled: 0,
    usedCredits: 0,
    startDate: undefined,
    endDate: undefined,
    status: "",
    statusRemarks: "",
    userType: "",
    lastLogin: undefined,
    phoneNumber: "",
    companyDetails: [],
    creditHistory: [],
  };
  constructor(
    private modalService: NgbModal,
    private dataService: DataServiceService,
    private route: ActivatedRoute,
    public dateHelper: DateHelperServiceService,
    private authService: AuthService
  ) {
    this.userId = this.route.snapshot.params.userId
      ? this.route.snapshot.params.userId
      : "";
    this.getUserData().then((data) => {
      this.isLoading = false;
    });
  }

  ngOnInit(): void {}

  openSuccessPopup(smallModalContent) {
    this.modalService.open(smallModalContent, { size: "sm" });
  }

  openFailPopup(smallModalContent2) {
    this.modalService.open(smallModalContent2, { size: "sm" });
  }

  showTopUpModal(topupModalContent) {
    this.modalService.open(topupModalContent, { size: "md" });
  }

  invalidTopup() {
    this.newCredits < 1 ? true : false;
  }

  async getUserData() {
    this.userData = await this.dataService.getUserDetailsById(this.userId);
    this.userData = this.userData[0];
    this.userData.creditHistory = this.userData.creditHistory?.sort((a, b) =>
      a.creditedAt > b.creditedAt ? 1 : -1
    );
  }

  updateTopUp() {
    const creditData: CreditHistory = {
      entitled: this.newCredits,
      available:
        Number(this.userData.totalCreditsEntitled) -
        Number(this.userData.usedCredits) +
        this.newCredits,
      editedBy: this.authService.getCurrentUser().userName,
      note: this.note,
    };
    this.dataService
      .topupCredits({
        userId: this.userId,
        creditHistory: creditData,
      })
      .then(() => {
        const but = document.getElementById("successBtn") as HTMLButtonElement;
        but.click();
        this.getUserData().then(() => {
          setTimeout(() => {
            this.modalService.dismissAll();
          }, 3000);
        });
      })
      .catch(() => {
        const but = document.getElementById("failBtn") as HTMLButtonElement;
        but.click();
      });
  }
}
